export default function RecruitmentRoute() {
  return null;
}
